import React from "react";

import createNamespace from "services/language";
import Route from "components/common/History/Route";
import { PROJECT_OVERVIEW } from "utils/constants/routes";

const Index = React.lazy(() => import("./index"));

const namespace = "projectOverview";

export default createNamespace({
  namespace,
  Component: function Main() {
    return (
      <>
        <Route path={PROJECT_OVERVIEW.ROOT} component={Index} />
      </>
    );
  },
});
